/**
 * iOS のセグメント（#152、docs/61 §5・★i、Figma「アカウントと氏名（10/8）」部品の「セグメント」）。
 *   ・地 --head（#EFEEE9）の角丸の溝に、選べるものを並べる。選んだものは白い地＋藍の太字＋影（色だけで伝えない＝太字と読み上げ）
 *   ・1つ 38px の高さ。押せる範囲は ::before で上下に広げて 44px（docs/10 の PC・脇役の押すところ）
 *   ・menu＝アカウントのメニューの中（role="menuitemradio"・aria-checked。↓↑ はメニューが回す）。それ以外は role="group" の中の aria-pressed のボタン
 *   ・文字の大きさ（TextSize）・写真の引き出しの向き（個人設定）・新しい行の仕入れ（見積・請求。#154）で使う。押した瞬間に効く設定だけに使う（保存ボタンと組まない）
 *   ・disabled＝押せない形（担当者・保存のあいだ。#154）
 *   ・id＝溝の id（ユーザー管理の権限 #roleSeg。#156）。is-wide＝全幅（端数処理。#156）
 */
import type { ReactNode } from "react";

/** disabled＝その1つだけ押せない形（送付状の作成の送付先＝帳票が入っているあいだ。#223） */
export type SegmentOption<T extends string> = { value: T; label: ReactNode; testId?: string; disabled?: boolean };

export function Segmented<T extends string>({
  options,
  value,
  onChange,
  labelledBy,
  label,
  menu = false,
  disabled = false,
  testId,
  className,
  id,
}: {
  options: readonly SegmentOption<T>[];
  value: T;
  onChange: (v: T) => void;
  /** 見える名前の文の id（無ければ label を読み上げの名前に） */
  labelledBy?: string | undefined;
  label?: string | undefined;
  menu?: boolean;
  disabled?: boolean | undefined;
  testId?: string | undefined;
  className?: string | undefined;
  id?: string | undefined;
}) {
  return (
    <span id={id} className={"segm" + (className ? ` ${className}` : "")} role="group" aria-labelledby={labelledBy} aria-label={labelledBy ? undefined : label} data-testid={testId}>
      {options.map((o) => {
        const on = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role={menu ? "menuitemradio" : undefined}
            aria-checked={menu ? on : undefined}
            aria-pressed={menu ? undefined : on}
            className={on ? "is-on" : undefined}
            disabled={disabled || !!o.disabled}
            onClick={() => onChange(o.value)}
            data-testid={o.testId}
          >
            {o.label}
          </button>
        );
      })}
    </span>
  );
}
